import { render, staticRenderFns } from "./StatusPrestij.vue?vue&type=template&id=9d7b4b3c"
import script from "./StatusPrestij.vue?vue&type=script&lang=js"
export * from "./StatusPrestij.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports